import { ROLES } from "./roles";
import { normalizeSessionRole } from "../identity/access";

export function displayName(user) {
  const name = String(user?.name || "").trim();
  if (name) return name;
  const email = String(user?.email || "").trim();
  if (email.includes("@")) return email.split("@")[0];
  return email || "User";
}

export function displayInitial(user) {
  const n = displayName(user);
  return (n[0] || "?").toUpperCase();
}

/** Badge/meta for a role string or full session user (super_admin flags win). */
export function roleMeta(roleOrUser) {
  if (roleOrUser && typeof roleOrUser === "object") {
    if (!roleOrUser.impersonated && (roleOrUser.is_super_admin || roleOrUser.can_impersonate)) {
      return ROLES.super_admin;
    }
    const key = normalizeSessionRole(roleOrUser.role);
    return ROLES[key] || ROLES.employee;
  }
  const key = normalizeSessionRole(roleOrUser);
  return ROLES[key] || ROLES.employee;
}

/** Map identity login /auth payloads onto the session Ops renders. */
export function opsUserFromAuthPayload(data) {
  if (!data || typeof data !== "object") return null;
  const nested =
    data.user && typeof data.user === "object" && !Array.isArray(data.user) ? data.user : {};
  const merged = { ...nested };
  Object.entries(data).forEach(([key, value]) => {
    if (key === "user" || value === undefined) return;
    merged[key] = value;
  });
  const role = normalizeSessionRole(merged.role || nested.role || "employee");
  return {
    ...merged,
    name: displayName({ name: merged.name, email: merged.email || nested.email }),
    role: ROLES[role] ? role : "employee",
    email: merged.email || nested.email || "",
  };
}

export function userEmployeeCode(user) {
  if (!user) return "";
  const c = user.employee_code ?? user.employeeCode;
  if (c != null && String(c).trim()) return String(c).trim();
  return "";
}

/** Client-side leave/admin staff search: name (first/last) or employee_code, partial, case-insensitive. */
export function staffMatchesSearch(emp, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const name = String(emp?.name || "").toLowerCase();
  const first = String(emp?.first_name || emp?.firstName || "").toLowerCase();
  const last = String(emp?.last_name || emp?.lastName || "").toLowerCase();
  const code = String(emp?.employee_code ?? emp?.employeeCode ?? "").toLowerCase();
  return name.includes(q) || first.includes(q) || last.includes(q) || code.includes(q);
}

export function isActiveStaffMember(emp) {
  if (!emp) return false;
  if (emp.active === false || emp.is_active === false) return false;
  return true;
}
